// 전화번호 유틸 모음

// 숫자만 남기는 정규화 (E.164 형식용, 국가코드 미포함 국내용)
export function normalizePhone(raw: string): string {
  if (!raw) return '';
  return String(raw).replace(/[^0-9]/g, '');
}

// 하이픈 포함 가독성 포맷 (010-1234-5678 형태)
export function formatPhoneKorean(raw: string): string {
  const num = normalizePhone(raw);
  if (num.length === 11) {
    return num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
  }
  if (num.length === 10) {
    return num.replace(/(\d{3})(\d{3,4})(\d{4})/, '$1-$2-$3');
  }
  if (num.length === 9) {
    return num.replace(/(\d{2,3})(\d{3,4})(\d{4})/, '$1-$2-$3');
  }
  return raw;
}

/** 입력 중 실시간 한국 전화·휴대폰 번호 포맷 */
export function formatPhoneKoreanInput(raw: string, maxDigits = 11): string {
  const num = normalizePhone(raw).slice(0, maxDigits);
  if (!num) return '';

  // 서울 02
  if (num.startsWith('02')) {
    if (num.length <= 2) return num;
    if (num.length <= 6) return `${num.slice(0, 2)}-${num.slice(2)}`;
    if (num.length <= 9) return `${num.slice(0, 2)}-${num.slice(2, 5)}-${num.slice(5)}`;
    return `${num.slice(0, 2)}-${num.slice(2, 6)}-${num.slice(6, 10)}`;
  }

  // 대표번호 1588, 1577, 1600 등
  if (/^1[568]\d{2}/.test(num)) {
    if (num.length <= 4) return num;
    return `${num.slice(0, 4)}-${num.slice(4, 8)}`;
  }

  // 휴대폰·지역번호
  if (num.length <= 3) return num;
  if (num.length <= 6) return `${num.slice(0, 3)}-${num.slice(3)}`;
  if (num.length <= 10) return `${num.slice(0, 3)}-${num.slice(3, 6)}-${num.slice(6)}`;
  return `${num.slice(0, 3)}-${num.slice(3, 7)}-${num.slice(7, 11)}`;
}


